import { useState } from "react"

export default function ExampleFooter({theme}) {
  const [isHovered01, setIsHovered01] = useState(false);
  const [isHovered02, setIsHovered02] = useState(false);
  const [isHovered03, setIsHovered03] = useState(false);
  const [isHovered04, setIsHovered04] = useState(false);
  const [isHovered05, setIsHovered05] = useState(false);
  const [isHovered06, setIsHovered06] = useState(false);
  const [isHovered07, setIsHovered07] = useState(false);
  const [isHovered08, setIsHovered08] = useState(false);
  const [isHovered09, setIsHovered09] = useState(false);
  const [isHovered10, setIsHovered10] = useState(false);
  return (
    <div className='exampleFooter' style={{backgroundColor:theme.primary_color, color:theme.accent_color}}>
      <div className="exampleFooter_col">
        <h4>מידע כללי</h4>
        <p onMouseEnter={()=>{setIsHovered01(true)}} onMouseLeave={()=>{setIsHovered01(false)}} style={{color:isHovered01 ? theme.secondary_color : theme.accent_color}}>עמוד הבית</p>
        <p onMouseEnter={()=>{setIsHovered02(true)}} onMouseLeave={()=>{setIsHovered02(false)}} style={{color:isHovered02 ? theme.secondary_color : theme.accent_color}}>אודות</p>
        <p onMouseEnter={()=>{setIsHovered03(true)}} onMouseLeave={()=>{setIsHovered03(false)}} style={{color:isHovered03 ? theme.secondary_color : theme.accent_color}}>צור קשר</p>
        <p onMouseEnter={()=>{setIsHovered04(true)}} onMouseLeave={()=>{setIsHovered04(false)}} style={{color:isHovered04 ? theme.secondary_color : theme.accent_color}}>דרושים</p>
      </div>
      <div className="exampleFooter_col">
        <h4>המוצרים שלנו</h4>
        <p onMouseEnter={()=>{setIsHovered05(true)}} onMouseLeave={()=>{setIsHovered05(false)}} style={{color:isHovered05 ? theme.secondary_color : theme.accent_color}}>קטגוריה 1</p>
        <p onMouseEnter={()=>{setIsHovered06(true)}} onMouseLeave={()=>{setIsHovered06(false)}} style={{color:isHovered06 ? theme.secondary_color : theme.accent_color}}>קטגוריה 2</p>
        <p onMouseEnter={()=>{setIsHovered07(true)}} onMouseLeave={()=>{setIsHovered07(false)}} style={{color:isHovered07 ? theme.secondary_color : theme.accent_color}}>קטגוריה 3</p>
      </div>
      <div className="exampleFooter_col">
        <h4>רשימת הסניפים שלנו</h4>
        <p onMouseEnter={()=>{setIsHovered08(true)}} onMouseLeave={()=>{setIsHovered08(false)}} style={{color:isHovered08 ? theme.secondary_color : theme.accent_color}}>סניף 1</p>
        <p onMouseEnter={()=>{setIsHovered09(true)}} onMouseLeave={()=>{setIsHovered09(false)}} style={{color:isHovered09 ? theme.secondary_color : theme.accent_color}}>סניף 2</p>
        <p onMouseEnter={()=>{setIsHovered10(true)}} onMouseLeave={()=>{setIsHovered10(false)}} style={{color:isHovered10 ? theme.secondary_color : theme.accent_color}}>סניף 3</p>
      </div>
    </div>
  )
}
